import { CircularProgress, Grid, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { formatNumberWithComma, toUtcEndOfDay, toUtcStartOfDay } from "../../../config";
import { apiGatewayAxiosInstance } from "../../../utils/axios";

export default function RCSAPIReports({ bot }) {

    const [counts, setCounts] = useState({
        totalSubmitted: 0,
        totalSentRCS: 0,
        totalDelivered: 0,
        totalRead: 0,
        totalFailed: 0,
        totalClicks: 0,
        totalDisableFailed: 0,

    });


    const [loading, setLoading] = useState(false);

    const getCampaignReportFromCampaignMIS = async () => {
        try {
            setLoading(true);

            const now = new Date();
            const start = new Date(now);

            const end = new Date(now);

            const dateRange = {
                startDate:start.toISOString().split('T')[0],  // Send full ISO strings to include time
                endDate: end.toISOString().split('T')[0],
            };
            const response = await apiGatewayAxiosInstance.post(`mis_server/master-mis/get-count-reports`, {
                botId: bot?.config?.rbmClientId,
                dateRange,
                correlationId: true
            });
            if (response.status === 200) {
                setCounts(response.data);
            }
        } catch (error) {
            let errorMessage = "Server not reachable.";
            if (error.response) {
                errorMessage = (error.response.data && error.response.data.message) ?? errorMessage;
            }
            // setErrorResponse(errorMessage);

        }

        setLoading(false);

    };
    useEffect(() => {
        getCampaignReportFromCampaignMIS();
    }, []);

    /* ================================================================= (UI) =================================================================== */
    return (
        <Grid
            container
            sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap",
            }}
        >
            <Grid
                item
                md={12}
                sx={{
                    // display: "flex",
                    alignItems: "center",
                    justifyContent: "start",
                    flexWrap: "wrap !important",
                }}
                gap={15}
            >
                <Grid>
                    <Typography
                        sx={{
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        TOTAL :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalSubmitted) ?? "-"
                        )}
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        color="GrayText"
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                        DISABLED :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalDisableFailed) ?? "-"
                        )}
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        color="primary"
                        sx={{
                            display: "flex",

                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <RcsSentIcon /> */}
                        SENT :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalSentRCS) ?? "-"
                        )}
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        color="green"
                        sx={{
                            display: "flex",

                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <RcsDeliveredIcon /> */}
                        DELIVERED :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalDelivered) ?? "-"
                        )}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color="error"
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <Unpublished fontSize='small' sx={{ margin: "5px" }} /> */}
                        FAILED :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalFailed) ?? "-"
                        )}
                    </Typography>
                </Grid>

                <Grid>
                    <Typography
                        color="darkblue"
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <RcsReadIcon /> */}
                        READ :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            formatNumberWithComma(counts.totalRead) ?? "-"
                        )}
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color="#9003fc"
                        sx={{
                            display: "flex",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        {/* <RcsReadIcon /> */}
                        CLICKS :{" "}
                        {loading ? (
                            <CircularProgress sx={{ marginLeft: ".3rem" }} color="inherit" size={10} />
                        ) : (
                            counts?.totalClicks ?? "-"
                        )}
                    </Typography>
                </Grid>
                {/* <Grid
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center !important",
                    }}
                >
                    <Typography
                        color='orange'
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center !important",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >

                        < AccessTime fontSize='small' sx={{ margin: "5px" }} />
                        PENDING : {
                            pendingRCSLoading ?
                                <CircularProgress
                                    sx={{ marginLeft: '.3rem' }}
                                    color="inherit" size={10}
                                />
                                :
                                pendingRCS ?? "-"
                        }
                    </Typography>
                </Grid>
                <Grid>
                    <Typography
                        color='GrayText'
                        sx={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center !important",
                            fontSize: "0.7rem !important",
                            fontWeight: "bold",
                        }}
                    >
                        <CurrencyExchange fontSize='small' sx={{ margin: "5px" }} />
                        SENT_REVOKED : {
                            revokedRCSLoading ?
                                <CircularProgress
                                    sx={{ marginLeft: '.3rem' }}
                                    color="inherit" size={10}
                                />
                                :
                                revokedRCS ?? "-"
                        }
                    </Typography>
                </Grid> */}
            </Grid>
        </Grid>
    );
}
